import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import PlayerRank from '../../components/PlayerRank';

const PeringkatPriaPage = () => {
  const [selectedLevel, setSelectedLevel] = useState('All');

  const handleLevelChange = (event) => {
    setSelectedLevel(event.target.value);
  };

  const players = [
    { rank: 1, name: 'Carlos Rodriguez', wins: 15, losses: 2, points: 2450, avatar: 'https://storage.googleapis.com/uxpilot-auth.appspot.com/avatars/avatar-2.jpg', level: 'Advanced' },
    { rank: 2, name: 'Alex Thompson', wins: 12, losses: 4, points: 2150, avatar: 'https://storage.googleapis.com/uxpilot-auth.appspot.com/avatars/avatar-8.jpg', level: 'Advanced' },
    { rank: 3, name: 'Diego Martinez', wins: 10, losses: 5, points: 1850, avatar: 'https://storage.googleapis.com/uxpilot-auth.appspot.com/avatars/avatar-3.jpg', level: 'Intermediate' },
    { rank: 4, name: 'John Doe', wins: 9, losses: 6, points: 1700, avatar: 'https://storage.googleapis.com/uxpilot-auth.appspot.com/avatars/avatar-4.jpg', level: 'Intermediate' },
    { rank: 5, name: 'Peter Jones', wins: 8, losses: 7, points: 1600, avatar: 'https://storage.googleapis.com/uxpilot-auth.appspot.com/avatars/avatar-7.jpg', level: 'Intermediate' },
    { rank: 6, name: 'Chris Lee', wins: 7, losses: 8, points: 1500, avatar: 'https://storage.googleapis.com/uxpilot-auth.appspot.com/avatars/avatar-9.jpg', level: 'Beginner' },
    { rank: 7, name: 'David Kim', wins: 6, losses: 9, points: 1400, avatar: 'https://storage.googleapis.com/uxpilot-auth.appspot.com/avatars/avatar-10.jpg', level: 'Beginner' },
    { rank: 8, name: 'James Brown', wins: 5, losses: 10, points: 1300, avatar: 'https://storage.googleapis.com/uxpilot-auth.appspot.com/avatars/avatar-11.jpg', level: 'Beginner' },
    { rank: 9, name: 'Robert Davis', wins: 4, losses: 11, points: 1200, avatar: 'https://storage.googleapis.com/uxpilot-auth.appspot.com/avatars/avatar-12.jpg', level: 'Beginner' },
    { rank: 10, name: 'Michael Miller', wins: 3, losses: 12, points: 1100, avatar: 'https://storage.googleapis.com/uxpilot-auth.appspot.com/avatars/avatar-13.jpg', level: 'Beginner' },
  ];

  const filteredPlayers = selectedLevel === 'All' ? players : players.filter(player => player.level === selectedLevel);

  return (
    <div className="bg-brand-dark text-white font-custom min-h-screen">
      <header className="bg-black/30 backdrop-blur-md">
        <div className="container mx-auto px-6 py-4 flex justify-between items-center">
          <Link to="/" className="flex items-center">
            <h1 className="text-3xl font-extrabold text-brand-lime tracking-tighter">5.AM</h1>
            <span className="text-xl font-semibold text-white ml-2 tracking-wide">Padel Club</span>
          </Link>
        </div>
      </header>

      <main className="py-12">
        <div className="container mx-auto px-6">
          <h2 className="text-4xl font-extrabold text-white text-center mb-8">Peringkat Pemain Pria</h2>
          <div className="mb-6 text-center">
            <label htmlFor="level-select" className="mr-4 text-lg font-semibold">Level:</label>
            <select
              id="level-select"
              value={selectedLevel}
              onChange={handleLevelChange}
              className="bg-brand-dark border border-brand-terracotta/30 rounded-md py-2 px-4 text-white focus:outline-none focus:ring-2 focus:ring-brand-lime"
            >
              <option value="All">All</option>
              <option value="Beginner">Beginner</option>
              <option value="Intermediate">Intermediate</option>
              <option value="Advanced">Advanced</option>
            </select>
          </div>
          <div className="bg-brand-dark rounded-xl p-8 border border-brand-terracotta/30">
            <div className="space-y-4">
              {filteredPlayers.map((player) => (
                <PlayerRank
                  key={player.rank}
                  rank={player.rank}
                  name={player.name}
                  points={player.points}
                  avatar={player.avatar}
                  isTopRank={player.rank === 1}
                />
              ))}
            </div>
          </div>
          <div className="text-center mt-8">
            <Link to="/" className="text-brand-lime hover:underline">Kembali ke Halaman Utama</Link>
          </div>
        </div>
      </main>
    </div>
  );
};

export default PeringkatPriaPage;
